export default __webpack_public_path__ + "static/media/lk_5.dc8b64fe.jpg";